import I18N from '@leverege/i18n';
const {
  t
} = I18N.ns('api-ui-fota-management.Constants');
export default {
  get deviceTitle() {
    return t('Icons.deviceTitle');
  },
  get deviceGroupTitle() {
    return t('Icons.deviceGroupTitle');
  },
  get deviceTypeTitle() {
    return t('Icons.deviceTypeTitle');
  },
  get firmwareReleaseTitle() {
    return t('Icons.firmwareReleaseTitle');
  },
  get firmwareApplicationTitle() {
    return t('Icons.firmwareApplicationTitle');
  },
  get firmwareComponentTitle() {
    return t('Icons.firmwareComponentTitle');
  },
  get 'leverege.fotaApi.deviceTitle'() {
    return t('Icons.deviceTitle');
  },
  get 'leverege.fotaApi.deviceGroupTitle'() {
    return t('Icons.deviceGroupTitle');
  },
  get 'leverege.fotaApi.deviceTypeTitle'() {
    return t('Icons.deviceTypeTitle');
  },
  get 'leverege.fotaApi.firmwareReleaseTitle'() {
    return t('Icons.firmwareReleaseTitle');
  },
  get 'leverege.fotaApi.firmwareApplicationTitle'() {
    return t('Icons.firmwareApplicationTitle');
  },
  get 'leverege.fotaApi.firmwareComponentTitle'() {
    return t('Icons.firmwareComponentTitle');
  },
  get deviceNav() {
    return t('Icons.deviceNav');
  },
  get deviceGroupNav() {
    return t('Icons.deviceGroupNav');
  },
  get deviceTypeNav() {
    return t('Icons.deviceTypeNav');
  },
  get firmwareReleaseNav() {
    return t('Icons.firmwareReleaseNav');
  },
  get firmwareApplicationNav() {
    return t('Icons.firmwareApplicationNav');
  },
  get firmwareComponentNav() {
    return t('Icons.firmwareComponentNav');
  },
  get 'leverege.fotaApi.deviceNav'() {
    return t('Icons.deviceNav');
  },
  get 'leverege.fotaApi.deviceGroupNav'() {
    return t('Icons.deviceGroupNav');
  },
  get 'leverege.fotaApi.deviceTypeNav'() {
    return t('Icons.deviceTypeNav');
  },
  get 'leverege.fotaApi.firmwareReleaseNav'() {
    return t('Icons.firmwareReleaseNav');
  },
  get 'leverege.fotaApi.firmwareApplicationNav'() {
    return t('Icons.firmwareApplicationNav');
  },
  get 'leverege.fotaApi.firmwareComponentNav'() {
    return t('Icons.firmwareComponentNav');
  },
  get groupNav() {
    return t('Icons.groupNav');
  }
};